import { render, staticRenderFns } from "./diysharingGoods.vue?vue&type=template&id=31912c62&scoped=true&"
import script from "./diysharingGoods.vue?vue&type=script&lang=js&"
export * from "./diysharingGoods.vue?vue&type=script&lang=js&"
import style0 from "./diysharingGoods.vue?vue&type=style&index=0&id=31912c62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31912c62",
  null
  
)

export default component.exports